'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var isClient = typeof window !== 'undefined';

var _require = require('./constant/browser_type'),
    UC_NEWS_INTL = _require.UC_NEWS_INTL;

var _require2 = require('./constant/deep_link'),
    SCHEME_LINK = _require2.SCHEME_LINK,
    INTENTS_LINK = _require2.INTENTS_LINK;

var debug = require('./util/debug');
var net = isClient ? require('@ali/network') : {};
var isIOS = isClient ? require('./util/is_ios')() : false;
var isAndroidChrome = isClient ? require('./util/is_android_chrome')() : false;
var uaObj = isClient && navigator.userAgent || '';
var iosVersion = isClient ? require('./util/get_ios_version')() : {};
var isFunction = require('./util/is_function');
var getQuery = require('./util/get_query');
var timeLoad = void 0; // 定时器对象

// 初始化绑定事件
function callApp(config) {

  var defaultWaitTime = isIOS ? 5000 : 3000;

  var _config$appType = config.appType,
      appType = _config$appType === undefined ? UC_NEWS_INTL : _config$appType,
      isAuto = config.isAuto,
      _config$waitTime = config.waitTime,
      waitTime = _config$waitTime === undefined ? defaultWaitTime : _config$waitTime,
      fail = config.fail,
      success = config.success,
      downloadUrl = config.downloadUrl;


  var startTime = Date.now();
  // 统计开始调用的打点
  require('@ali/log').logEvent('applink', 'startOpen', { isAuto: isAuto, appType: appType });

  // 如果存在则取消之后再一次执行
  timeLoad && clearInterval(timeLoad);

  // 监听唤起结果，启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
  var _count = 0;
  timeLoad = setInterval(function () {
    _count++;
    var timeDuration = Date.now() - startTime;
    if (_count >= 100 || timeDuration > waitTime) {
      clearInterval(timeLoad);
      timeLoad = null;

      // 执行时间超过3秒，界面不可见，则大致判断为APP成功唤起了。（有一定的误差,例如在IOS出现询问窗口的时候）
      if (timeDuration > waitTime || document.hidden || document.webkitHidden || document.msHidden) {
        // 唤起成功
        // success
        debug('appLink open success');
        require('@ali/log').logEvent('applink', 'tryOpenSuccess', { isAuto: isAuto, appType: appType });

        isFunction(success) && success();
      } else {
        // 唤起失败
        // fail
        debug('appLink open fail');
        require('@ali/log').logEvent('applink', 'tryOpenFail', { isAuto: isAuto, appType: appType });

        isFunction(fail) && fail();

        // 增加延迟，避免网络阻塞，日志发送不出去
        setTimeout(function () {
          // 如果存在downloadUrl,并且不是自动唤起的就跳转下载地址
          if (downloadUrl && !isAuto) {
            window.location.href = downloadUrl;
          }
        }, 200);
      }
    }
  }, 20);

  // 尝试唤起
  tryCallApp(config);
}

function tryCallApp(config) {
  var downloadUrl = config.downloadUrl,
      _config$appType2 = config.appType,
      appType = _config$appType2 === undefined ? UC_NEWS_INTL : _config$appType2,
      isAuto = config.isAuto;

  // 如果没有配置的话，就使用当前路径

  var url = config.url || window.location.href;

  // 追加参数
  var queryData = _extends({}, { isFromAppLink: true, entry: getQuery('entry') }, config && config.query || {});
  url = net.parseQuery(queryData, url);
  url = net.ucParam(url);

  // Android 上的 Chrome 才能使用 intent 协议
  if (isAndroidChrome) {
    url = INTENTS_LINK[appType] && INTENTS_LINK[appType].replace(/{\s*goToURL\s*}/, encodeURIComponent(url));
    if (config.intentFallbackUrl) {
      url = url.replace(';end', ';S.browser_fallback_url=' + encodeURIComponent(config.intentFallbackUrl) + ';end');
    }
  } else {
    url = SCHEME_LINK[appType] && SCHEME_LINK[appType].replace(/{\s*goToURL\s*}/, encodeURIComponent(url));
  }
  debug('scheme唤起的URL', url);

  // 针对国际版UC News的在国际版的UC Browser唤起不成功跳转信息流的特殊处理
  if (appType === UC_NEWS_INTL && uaObj.toLowerCase().indexOf('ucbrowser') > -1) {
    if (downloadUrl && !isAuto) {
      url = url.replace(/{\s*downloadUrl\s*}/, downloadUrl);
    } else {
      url = url.replace(/{\s*downloadUrl\s*}/, '');
    }
  }

  if (iosVersion > 9) {
    // IOS 9之后必须要location.href打开
    window.location.href = url;
  } else if (isAndroidChrome) {
    // intents 协议不能用 iframe.src , 未安装 app 的情况下点击 intent 协议链接也不会打开一个 404 的 tab
    window.location.href = url;
  } else {
    var iFrame = document.createElement('iframe');
    iFrame.style.display = 'none';
    iFrame.src = url;
    // 运行在head中
    if (!document.body) {
      setTimeout(function () {
        document.body.appendChild(iFrame);
      }, 0);
    } else {
      document.body.appendChild(iFrame);
    }
  }
}

module.exports = callApp;